import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgValue = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M.795 10.816a.72.72 0 0 0 1.032-.009l2.617-2.72q.095-.095.197-.095.096 0 .19.096l2.61 2.733q.249.267.511.392.264.125.541.125.534 0 1.053-.517L12.55 7.77l1.14 1.16q.161.162.337.162a.48.48 0 0 0 .321-.125.67.67 0 0 0 .205-.355l1.103-4.344a.5.5 0 0 0-.036-.37.55.55 0 0 0-.256-.25A.5.5 0 0 0 15 3.61l-4.29 1.108a.66.66 0 0 0-.352.207.5.5 0 0 0-.124.325.46.46 0 0 0 .16.332l1.134 1.153L8.69 9.66q-.096.104-.198.104-.094 0-.19-.104l-2.61-2.726a1.7 1.7 0 0 0-.518-.391 1.23 1.23 0 0 0-1.067-.008q-.255.118-.52.4L.79 9.801a.72.72 0 0 0 .005 1.014"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgValue);
export default ForwardRef;
